import { useEffect, useState, useReducer, createContext } from 'react'
import styled from 'styled-components'
import { csvParse } from 'd3'

import StageScreen from './StageScreen/StageScreen'
import EndScreen from './EndScreen/EndScreen'

import GameState from './game/GameState'
import Card from './game/Card'
import encounterData from './assets/encounters.csv'
import Deck from './game/Deck'

export const GameContext = createContext({ gameState: null })

let cardsData

function gameReducer(gameState, action) {
  const { type, payload } = action
  switch(type) {
    case 'LOAD_GAME':
      return gameInit(cardsData)
    case 'PLAY_CARD': {
      return payload.card.play(gameState)
    }
    default:
      return gameState
  }
}

function gameInit(cardsData) {
  const initialDeck = new Deck({ cards: cardsData })
  const shuffledDeck = initialDeck.shuffle()
  const [drawnCards, newDeck] = shuffledDeck.draw(2)
  const initialGameState = new GameState({
    deck: newDeck,
    hand: drawnCards
  })
  return initialGameState
}

const Container = styled.div`
  width: 1024px;
  height: 768px;
  margin: auto;
`

function App() {
  const [ isLoading, setIsLoading ] = useState(true)
  const [ gameState, dispatch ] = useReducer(gameReducer, null, gameInit)
  
  useEffect(() => {
    fetch(encounterData)
      .then(response => response.text())
      .then(text => {
        cardsData = csvParse(text, Card.fromCsv).filter(card => card.id)
        dispatch({
          type: 'LOAD_GAME'
        })
        setIsLoading(false)
      })
  }, [])
  
  return (
    <Container>
      { isLoading ?
        'Loading ...' :
        <GameContext.Provider value={{gameState, dispatch}}>
          { gameState.isOver || gameState.isWon ?
            <EndScreen /> :
            <StageScreen /> 
          }
        </GameContext.Provider>
      }
    </Container>
  );
}

export default App;
